import * as React from 'react';
import { 
  Alert,
  Button, 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogContentText, 
  DialogTitle, 
  CircularProgress 
} from '@mui/material';
import StyledTypography from '../../helper/styled_typography';
import { styled } from '@mui/material/styles';
import useIsMobile from '../../hooks/useIsMobile';
import { MOBILE_TOUCH_MIN_PX, mobileDialogPaperSx } from '../../theme/mobileLayout';

const StyledDeleteButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  color: theme.palette.common.white,
  fontWeight: 700,
  padding: '8px 24px',
  '&:hover': {
    backgroundColor: theme.palette.error.dark,
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,
  }
}));

const StyledCancelButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.secondary,
  borderColor: theme.palette.divider,
  fontWeight: 600,
  '&:hover': {
    borderColor: theme.palette.text.primary,
    backgroundColor: theme.palette.action.hover,
  },
}));

export default function DeleteSearchDialog({ 
  open, 
  onClose, 
  onConfirm, 
  searchName, 
  isDeleting,
  error = null,
}) {
  const isMobile = useIsMobile();

  return (
    <Dialog 
      open={open} 
      onClose={isDeleting ? undefined : onClose}
      fullWidth
      fullScreen={isMobile}
      maxWidth="sm"
      PaperProps={{sx: mobileDialogPaperSx(isMobile, {maxWidth: 480})}}
    >
      <DialogTitle sx={{pb: 1}}>
        <StyledTypography component="span" variant="h6">Delete Saved Search?</StyledTypography>
      </DialogTitle>
      
      <DialogContent dividers>
        {error && <Alert severity="error" sx={{mb: 2}}>{error}</Alert>}
        <DialogContentText sx={{mb: 2, color: 'text.secondary'}}>
            Are you sure you want to permanently delete <b>"{searchName}"</b>? 
            <br />
            This saved search cannot be recovered. Its enrichment data will remain available from each company.
        </DialogContentText>
      </DialogContent>
      
      <DialogActions sx={{ padding: "16px 24px" }}>
        <StyledCancelButton 
            variant="outlined" 
            onClick={onClose} 
            disabled={isDeleting}
            sx={{minHeight: MOBILE_TOUCH_MIN_PX}}
        >
            Cancel
        </StyledCancelButton>
        <StyledDeleteButton 
            onClick={onConfirm} 
            variant="contained" 
            disabled={isDeleting} 
            autoFocus
            sx={{minHeight: MOBILE_TOUCH_MIN_PX}}
        >
            {isDeleting ? <CircularProgress size={24} color="inherit" /> : "Permanently delete"}
        </StyledDeleteButton>
      </DialogActions>
    </Dialog>
  );
}
